import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Profile from "./Profile";
import Permissions from "./Permissions";
import Teams from "./Teams";

const SettingsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    searchParams.get("tab") || "profile"
  );

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    const modeParam = searchParams.get("mode");

    if (!tabParam) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("tab", "profile");
      setSearchParams(newParams);
      setActiveTab("profile");
    } else {
      setActiveTab(tabParam);

      if (tabParam !== "teams" && modeParam) {
        const newParams = new URLSearchParams(searchParams);
        newParams.delete("mode");
        setSearchParams(newParams);
      }
    }
  }, [searchParams, setSearchParams]);

  const handleTabChange = (tab: string) => {
    const newParams = new URLSearchParams(searchParams);

 
    newParams.set("tab", tab);
    if (tab !== "teams") {
      newParams.delete("mode");
    }

    setSearchParams(newParams);
    setActiveTab(tab);
  };

  return (
    <section className="mx-auto px-4 py-6">
      <header className="mb-6">
        <nav className="flex space-x-6 border-b border-gray-200">
          <button
            onClick={() => handleTabChange("profile")}
            className={`
              pb-2 text-sm font-medium transition-colors duration-300
              ${
                activeTab === "profile"
                  ? "text-red-600 border-b-2 border-black"
                  : "text-slate-500 hover:text-gray-800"
              }
            `}
          >
            Profile
          </button>
          <button
            onClick={() => handleTabChange("teams")}
            className={`
              pb-2 text-sm font-medium transition-colors duration-300
              ${
                activeTab === "teams"
                  ? "text-red-600 border-b-2 border-black"
                  : "text-slate-500 hover:text-gray-800"
              }
            `}
          >
            Teams
          </button>
          <button
            onClick={() => handleTabChange("permissions")}
            className={`
              pb-2 text-sm font-medium transition-colors duration-300
              ${
                activeTab === "permissions"
                  ? "text-red-600 border-b-2 border-black"
                  : "text-slate-500 hover:text-gray-800"
              }
            `}
          >
            Permissions
          </button>
        </nav>
      </header>

      {/* Conditional rendering based on active tab */}
      <main>
        {activeTab === "profile" && <Profile />}
        {activeTab === "teams" && <Teams />}
        {activeTab === "permissions" && <Permissions />}
      </main>
    </section>
  );
};

export default SettingsPage;
